import { createStore, combineReducers } from 'redux'
import AccountReducer from './account/reducer'
import MasterReducer from './master/reducer'
import TableReducer from './table/reducer'
import PopupReducer from './popup/reducer'
import StationsReducer from './stations/reducer'

import MgtOrgReducer from './mgt-org/reducer'
import MgtStationReducer from './mgt-station/reducer'
import MgtUserReducer from './mgt-user/reducer'
import MgtPermission from './mgt-permission/reducer'
import MgtSensorDataReducer from './mgt-sensor-data/reducer'
import CompareGraphReducer from './compare-graph/reducer'

const allReducers = combineReducers({ 
    master: MasterReducer,
    acc: AccountReducer,
    table: TableReducer,
    popup: PopupReducer,
    mgtStation: MgtStationReducer,
    mgtUser: MgtUserReducer,
    mgtPermission: MgtPermission,
    mgtSensorData: MgtSensorDataReducer,
    stations: StationsReducer,
    compareGraph: CompareGraphReducer,
    MgtOrg: MgtOrgReducer
})

export default createStore(allReducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())